import Modal from "../../../common/ui/modal";


const DeleteContentLine = ({contentLine, contentLineIndex, handleRemoveContentLine}) => {

    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Line"
                content={[{
                    text: `Are you sure you wish to delete the below line?`,
                    classes: "text-center"
                }, {
                    text: `${contentLine?.isImage ? 'Image - ' : ''} ${contentLine?.text} `,
                    classes: "text-blue font-bold text-center"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={true}
                buttonClasses={"button-red-outline px-1 py-1"}
                handleConfirm={() => {
                    handleRemoveContentLine(contentLineIndex)
                }}
            />
        </>
    )
}

export default DeleteContentLine
